function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.375 11.42h-5.5m11.249 0h-3.068M5.375 5.773h-2.5m11.249 0H7.988m0-1.534v3.068m3.068 5.647V9.886",
  stroke: "#060505",
  strokeLinecap: "square",
  strokeLinejoin: "bevel"
});

function SvgCompare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "compare_svg__svg-icon compare_svg__svg-icon--compare compare_svg__option-link__svg"
  }, props), _ref);
}

export default SvgCompare;